<template>
  <v-form
    ref="form"
    v-model="valid"
    v-if="challenge"
  >
    <v-card
      class="ma-4"
      elevation="4"
    >
      <v-card-title>
        {{ title }}
  
        <v-spacer/>
  
        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="save"
        >
          {{ saveLabel }}
        </v-btn>
      </v-card-title>
  
      <v-divider></v-divider>
  
      <v-tabs vertical>
        <v-tab to="#detail">
          <v-icon left>
            mdi-pencil-outline
          </v-icon>
          詳細
        </v-tab>
        <v-tab to="#readme">
          <v-icon left>
            mdi-note-text-outline
          </v-icon>
          問題文
        </v-tab>
        <v-tab to="#kernel">
          <v-icon left>
            mdi-note-text-outline
          </v-icon>
          カーネル
        </v-tab>
        <v-tab to="#tb">
          <v-icon left>
            mdi-note-text-outline
          </v-icon>
          テストベンチ
        </v-tab>
  
        <v-tab-item value="detail">
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <h3>概要と期間</h3>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.name"
                      :rules="nameRules"
                      :counter="20"
                      label="チャレンジ名"
                      required
                    ></v-text-field>
                  </v-col>
            
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="challenge.description"
                      :rules="descRules"
                      :counter="100"
                      label="短い説明文"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="8">
                    <v-combobox
                      v-model="challenge.tags"
                      :items="all_tags.tags"
                      chips
                      clearable
                      label="タグ"
                      multiple
                    >
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="removeTag(item)"
                        >
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="challenge.expireAtText"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="challenge.expireAtText"
                          label="提出期限"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="challenge.expireAtText"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modal = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(challenge.expireAtText)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <h3>合成制約</h3>

                    <v-text-field
                      v-model="challenge.regulation.clockPeriod"
                      :rules="clockPeriodRules"
                      label="クロック周期（ナノ秒）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <h3>採点条件</h3>

                    <v-checkbox
                      v-model="challenge.regulation.do_synth"
                      label="論理合成を実行する"
                    ></v-checkbox>
                  </v-col>
  
                  <v-col cols="12" md="12">
                    <h3>リソース制限</h3>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.regulation.max_ff"
                      :rules="integerRules"
                      label="最大FF使用量（負数で制限なし）"
                      required
                    ></v-text-field>
                  </v-col>
      
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.regulation.max_lut"
                      :rules="integerRules"
                      label="最大LUT使用量（負数で制限なし）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.regulation.max_dsp"
                      :rules="integerRules"
                      label="最大DSP使用量（負数で制限なし）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.regulation.max_bram"
                      :rules="integerRules"
                      label="最大BRAM使用量（負数で制限なし）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="challenge.regulation.max_uram"
                      :rules="integerRules"
                      label="最大URAM使用量（負数で制限なし）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="12">
                    <h3>実行時間制限</h3>
                  </v-col>
      
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="challenge.regulation.csimTimeout"
                      :rules="timeoutRules"
                      label="CSim タイムアウト（分）"
                      required
                    ></v-text-field>
                  </v-col>
      
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="challenge.regulation.hlsTimeout"
                      :rules="timeoutRules"
                      label="HLS タイムアウト（分）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="challenge.regulation.cosimTimeout"
                      :rules="timeoutRules"
                      label="CoSim タイムアウト（分）"
                      required
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="challenge.regulation.synTimeout"
                      :rules="timeoutRules"
                      label="論理合成タイムアウト（分）"
                      required
                    ></v-text-field>
                  </v-col>
                  
                  <v-col cols="12" md="12">
                    <h3>ビルド条件</h3>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="challenge.regulation.cxxflags"
                      :rules="textRules"
                      :counter="100"
                      label="追加のコンパイルフラグ（オプション）"
                    ></v-text-field>
                  </v-col>
      
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="challenge.regulation.ldflags"
                      :rules="textRules"
                      :counter="100"
                      label="追加のリンクフラグ（オプション）"
                    ></v-text-field>
                  </v-col>
      
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="challenge.regulation.tool_ver"
                      :items="tool_vers"
                      label="ツールのバージョン"
                    ></v-select>
                  </v-col>
  
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
  
        <v-tab-item value="readme">
          <v-container v-if="challenge.files">
            <h3 class="mb-3">README.md</h3>
            <v-switch
              v-model="preview"
              label="プレビュー"
            ></v-switch>
            <v-textarea
              v-model="challenge.files.readme"
              v-if="!preview"
              rows="16"
              outlined
              clearable
              required
            ></v-textarea>
            <Markdown v-if="preview" :markdown-text="challenge.files.readme" />
          </v-container>
        </v-tab-item>
  
        <v-tab-item value="kernel">
          <v-card flat>
            <v-card-text>
              <h3 class="mb-3">カーネルヘッダー (kernel.hpp)</h3>
              <v-textarea
                v-model="challenge.files.kernel_header"
                rows="8"
                outlined
                clearable
              ></v-textarea>
  
              <h3 class="mb-3">カーネルソースの雛形 (kernel.cpp)</h3>
              <v-textarea
                v-model="challenge.files.kernel_source"
                rows="8"
                outlined
                clearable
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-tab-item>
  
        <v-tab-item value="tb">
          <v-card flat>
            <v-card-text>
              <h3 class="mb-3">検証用テストベンチ（公開）</h3>
              <v-textarea
                v-model="challenge.files.public_tb"
                rows="8"
                outlined
                clearable
              ></v-textarea>
  
              <h3 class="mb-3">採点用テストベンチ（非公開）</h3>
              <v-textarea
                v-model="challenge.files.private_tb"
                rows="8"
                outlined
                clearable
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-form>
</template>

<style>
textarea {
  font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
}
.v-tab {
  justify-content: left !important;
  text-transform: none !important;
}
</style>

<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
import Markdown from '@/components/Markdown.vue'

export default {
  components: {
    Markdown,
  },
  data: () => ({
    valid: false,
    modal: false,
    preview: false,
    all_tags: [],
    tool_vers: ['2022.1', '2021.2', '2021.1', '2020.2'],
    nameRules: [
      v => !!v || 'タイトルを入力してください',
      v => (v && v.length <= 20) || 'タイトルは20文字以下で入力してください',
    ],
    descRules: [
      v => !!v || '説明文を入力してください',
      v => (v && v.length <= 100) || '説明文は100文字以下で入力してください',
    ],
    clockPeriodRules: [
      v => (v && /^[0-9]+(\.[0-9]+)?$/.test(v) && !isNaN(parseFloat(v))) || '小数値を入力してください',
      v => (v && v.length <= 10) || 'クロック周期は10文字以下で入力してください',
      v => (v && parseFloat(v) >= 2 && parseFloat(v) <= 20) || 'クロック周期は 2 ~ 20 の間で入力してください',
    ],
    timeoutRules: [
      v => (v && /^[0-9]+$/.test(v) && !isNaN(parseInt(v))) || '整数値を入力してください',
      v => (v && v.length <= 10) || 'タイムアウトは10文字以下で入力してください',
      v => (v && parseInt(v) >= 1 && parseInt(v) <= 60) || 'タイムアウトは 1 ~ 60 の間で入力してください',
    ],
    integerRules: [
      v => (v && v.length <= 10) || '整数値は10文字以下で入力してください',
      v => (v && /^-?[0-9]+$/.test(v) && !isNaN(parseInt(v))) || '整数値を入力してください',
    ],
    textRules: [
      v => (!v || v.length <= 100) || '100文字以下で入力してください',
    ],
    //dateRules: [
    //  v => (v && (new Date(v)).getTime() >= new Date(new Date().toISOString().substr(0, 10))) || '期限を正しく入力してください',
    //],
  }),
  props: ['challenge', 'title', 'saveLabel'], 
  methods: {
    removeTag(item) {
      this.challenge.tags.splice(this.challenge.tags.indexOf(item), 1)
      this.challenge.tags = [...this.challenge.tags]
    },
    save() {
      // Save tags
      if (this.challenge.tags) {
        db.doc("common/tags").update({
          tags: firebase.firestore.FieldValue.arrayUnion(...this.challenge.tags),
        })
      }

      // Generate regulation.txt
      const regulation = this.challenge.regulation
      let regulationText = ""
      regulationText += `target_clock_period_ns=${regulation.clockPeriod}\n`
      regulationText += `vitis_version=${regulation.tool_ver}\n`
      regulationText += `csim_timeout=${regulation.csimTimeout}m\n`
      regulationText += `hls_timeout=${regulation.hlsTimeout}m\n`
      regulationText += `cosim_timeout=${regulation.cosimTimeout}m\n`
      regulationText += `syn_timeout=${regulation.synTimeout}m\n`
      regulationText += `cxxflags="${regulation.cxxflags}"\n`
      regulationText += `ldflags="${regulation.ldflags}"\n`

      // Parse date
      const expireAt = firebase.firestore.Timestamp.fromDate(new Date(this.challenge.expireAtText + "T23:59:59+09:00"))

      this.$emit('save', {
        ...this.challenge,
        regulation_text: regulationText,
        expireAt: expireAt,
      })
    },
  },
  created() {
    this.$bind("all_tags", db.doc("common/tags"))
  }
};
</script>

